// extracted by mini-css-extract-plugin
export default {"link":"ExternalCardLink_link__PBG1Q"};